import { Dispatch } from 'redux'
import * as Api from 'lib/api'

export function sendPutMessagesRead(shopId: number) {
  return async (dispatch: Dispatch) => {
    // Send Put messages/read
    await Api.callApi(Api.HttpMethod.put, `messages/read`, JSON.stringify({ shopId: shopId }), dispatch)
  }
}
